import React from "react";
import "./TablePannel.style.scss";

const TablePannel = ({
  data,
  addHandler,
  cancelHandler,
  checkBoxHandler,
  selectedElementLength,
}) => {
  return (
    <div className="table-pannel">
      <div className="table-pannel__main-content">
        <div className="table-pannel__main-content_heading">
          Securities which are not part of My Universe
        </div>
        <div className="table-pannel__main-content_table">
          {data && data.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th className="sticky" style={{ width: "50px" }}></th>
                  <th className="sticky">SECURITIES</th>
                  <th className="sticky">ASSET CLASS</th>
                  <th className="sticky">CLASSIFICATION</th>
                  <th className="sticky">STYLE</th>
                  <th className="sticky">ALLOCATION(%)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((e, i) => (
                  <tr key={i}>
                    <td style={{ width: "50px" }}>
                      <input
                        type="checkbox"
                        index={i}
                        onClick={(e) => checkBoxHandler(e)}
                      />
                    </td>
                    <td>{e["fund_name"]}</td>
                    <td>{e["fund_asset_class_focus"]}</td>
                    <td>{e["new_classification"]}</td>
                    <td>{e["new_style"]}</td>
                    <td>{e["val"]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>
      </div>
      <div className="table-pannel__button">
        <div className="table-pannel__button-group">
          {selectedElementLength && selectedElementLength > 0 ? (
            <button
              className="btn text-uppercase"
              onClick={(e) => addHandler(e)}
            >
              Add to MyUniverse
            </button>
          ) : null}

          <button
            className="btn text-uppercase"
            onClick={(e) => cancelHandler(e)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TablePannel;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/tablePannel/TablePannel.jsx